$('a.erpl_smooth-scroll').on("click", function (e) {
    e.preventDefault();

    let offsetTop = 0;
    let duration = 1000;
    let target;
    let hash = this.hash ? decodeURIComponent(this.hash) : null;

    // Si menu, défaut offset : 40
    if ($('.erpl_header-menu').length) {
        offsetTop = 40;
    }

    // Si offset spécifiée
    if ($(this).attr('data-scroll-offset')) {
        offsetTop = $(this).attr('data-scroll-offset')
    }

    if ($(this).attr('data-scroll-speed') || $(this).attr('data-scroll-duration')) {
        duration = $(this).attr('data-scroll-speed') || $(this).attr('data-scroll-duration')
    }

    if ($(hash).length) {
        target = $(hash)[0]
    } else {
    	let nameSelector = '[name="' + hash.replace("#", "") + '"]';
	    if ($(nameSelector).length) {
	        target = $(nameSelector)[0];
	    }
    }

    if (hash && target) {

        $("html, body").animate({ scrollTop: $(target).offset().top - offsetTop }, parseInt(duration));

        setTimeout(() => {
            $(hash).trigger("focus")
        }, parseInt(duration));

        // Ajout hash dans l'URL
        window.location.hash = hash;
    }

});